import { $ArithmeticOperation, ArithmeticOperation } from '@suntex.fim/enums';
import { VideoPlayer } from '@suntex.fim/ui';

export interface VifVideoProps {
  operation: ArithmeticOperation;
  stage: number;
  /** Called when the video finishes playing. */
  onComplete: () => void;
}

/** A VIF "video" stage: plays an instructional clip via JWPlayer. */
export function VifVideo({ operation, stage, onComplete }: VifVideoProps) {
  const { slug } = $ArithmeticOperation.describe(operation);
  const videoUrl = `https://cdn.firstinmath.com/content/video/vif-${slug}-${stage}.mp4`;

  return <VideoPlayer file={videoUrl} onComplete={onComplete} />;
}
